export default __webpack_public_path__ + "media/images/chefs-3-3c4274c1dae36d43437e2bc5bad38c88.png";